import React from "react";
import {
  Segment,
  Container,
  Grid,
  Header,
  List,
  Divider
} from "semantic-ui-react";
import { navigateToSection } from "./../js";
import colors from "../js/colors";

const gotoParceiro = parceiro => {
  switch (parceiro) {
    case "unicobox":
      window.open("http://www.unicobox.com.br/", "_blank");
      break;
    default:
      break;
  }
};

export default () => {
  return (
    <Segment
      inverted
      vertical
      style={{
        backgroundColor: colors.dark,
        marginBottom: "0",
        marginTop: 100,
        bottom: 0
      }}
    >
      <Container>
        <Grid divided inverted stackable columns="equal">
          <Grid.Row style={{ marginBottom: 25 }}>
            <Grid.Column textAlign="center">
              <Header
                inverted
                as="h3"
                content="Varais Alpha"
                style={{ color: colors.mediumDark }}
              />
              <Header
                inverted
                as="h4"
                content="Atendimento de qualidade, visando o produto que atenda a sua necessidade."
                style={{ color: colors.mediumDark }}
              />
            </Grid.Column>
          </Grid.Row>
          <Divider />
          <Grid.Row style={{ marginTop: 25 }}>
            <Grid.Column>
              <Header
                inverted
                as="h3"
                content="Sitemap"
                style={{ color: colors.mediumDark }}
              />
              <List link inverted>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-home")}
                >
                  Home
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-empresa")}
                >
                  Empresa
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-produtos")}
                >
                  Produtos
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-imagens")}
                >
                  Imagens
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-contato")}
                >
                  Contato
                </List.Item>
              </List>
            </Grid.Column>
            <Grid.Column>
              <Header
                inverted
                as="h3"
                content="Parceiros"
                style={{ color: colors.mediumDark }}
              />
              <List link inverted>
                <List.Item as="a" onClick={() => gotoParceiro("unicobox")}>
                  UnicoBox
                </List.Item>
              </List>
            </Grid.Column>
            <Grid.Column>
              <Header
                inverted
                as="h3"
                content="Linha de Produtos"
                style={{ color: colors.mediumDark }}
              />
              <List link inverted>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-linha-produtos")}
                >
                  Varal Tradicional
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-produtos")}
                >
                  Varal Individual
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-produtos")}
                >
                  Varal Sanfonado
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-produtos")}
                >
                  Varal Mágico
                </List.Item>
                <List.Item
                  as="a"
                  onClick={() => navigateToSection("section-redes-protecao")}
                >
                  Redes de Proteção
                </List.Item>
              </List>
            </Grid.Column>
            <Grid.Column>
              <Header
                inverted
                as="h3"
                content="Atendimento"
                style={{ color: colors.mediumDark }}
              />
              <p>Seg. à Sex. das 8:30h - 17:30h</p>
              <p>Sábados 9:00h - 13:00h</p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ marginTop: 50, marginBottom: 0 }}>
            <Grid.Column textAlign="center">
              <List.Item
                inverted="true"
                content="Varais Alpha © Copyright 2019 - Todos os Direitos Reservados"
                style={{ color: colors.light }}
              />
              <a
                href="http://www.jonathanjuliani.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                @JJD
              </a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};
